import React from 'react';
import { Button, Modal, ModalProvider, ModalTrigger, useAnalytics } from 'telia-front-react';
import { InternetForm } from '../form/InternetForm';
const RequestFasterInternetModalButton = (props) => {
    const { buttonProps, modalProps, formType } = props;
    const { push } = useAnalytics();
    return (React.createElement(ModalProvider, { isClosable: true },
        React.createElement(ModalTrigger, null,
            React.createElement(Button, { variant: "secondary", block: true, ...buttonProps, onClick: (e) => {
                    var _a;
                    push('Link - Modal - Kiirema interneti sooviavaldus');
                    (_a = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(buttonProps, e);
                    return true;
                } })),
        React.createElement(Modal, { ...modalProps },
            React.createElement(InternetForm, { manuallySetFormType: formType }))));
};
export default RequestFasterInternetModalButton;
